import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItemsComponent } from '@app/features/items/items/items.component';
import { AddItemComponent } from '@app/features/items/add-item/add-item.component';
import { ViewItemComponent } from '@app/features/items/view-item/view-item.component';
import { EditItemComponent } from '@app/features/items/edit-item/edit-item.component';

const routes: Routes = [
  { path: '', component: ItemsComponent },
  { path: 'add', component: AddItemComponent },
  { path: ':itemId/edit', component: EditItemComponent },
  { path: ':itemId', component: ViewItemComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItemsRoutingModule { }
